export const MAX_FILE_MEGABYTES = 5

export const MAX_FILE_BYTES = MAX_FILE_MEGABYTES * 1024 * 1024

export const blobTypes = Object.freeze({
  assetDescription: {
    str: 'asset_description',
    num: 1
  },
  fundOverview: {
    str: 'fund_overview',
    num: 2
  },
  fundUpdate: {
    str: 'fund_update',
    num: 4
  },
  navUpdate: {
    str: 'nav_update',
    num: 8
  },
  fundDocument: {
    str: 'fund_document',
    num: 16
  },
  syndicate_kyc: {
    str: 'alpha',
    num: 32
  },
  bravo: {
    str: 'bravo',
    num: 64
  },
  charlie: {
    str: 'charlie',
    num: 128
  },
  delta: {
    str: 'delta',
    num: 256
  },
  tokenTerms: {
    str: 'token_terms',
    num: 512
  },
  tokenMetrics: {
    str: 'token_metrics',
    num: 1024
  },
  kycForm: {
    str: 'kyc_form',
    num: 2048
  }
})

export const blobFilters = Object.freeze({
  fundID: 'fund_id',
  tokenCode: 'token_code',
  type: 'type',
  fundOwner: 'fund_owner',
  kycSequence: 'kyc_sequence'
})

export const kycDocumentTypes = Object.freeze({
  kycIdDocument: 'kyc_id_document',
  kycProofOfAddress: 'kyc_poa',
  kycSelfie: 'kyc_selfie',
  kycTaxIdentification: 'kyc_tax_identification',
  kycTaxReturns: 'kyc_tax_returns',
  kycPersonalIncome: 'kyc_personal_income',
  kycJointIncome: 'kyc_joint_income',
  kycPriorPersonalIncome: 'kyc_prior_personal_income',
  kycPriorJointIncome: 'kyc_prior_joint_income',
  kycNetWorth: 'kyc_net_worth',
  kycEstateNetValue: 'kyc_estate_net_value',
  kycLiquidAssets: 'kyc_liquid_assets',
  kycOtherAssets: 'kyc_other_assets',
  kycOriginationCertificate: 'company_origination_certificate',
  kycInvestmentPresentation: 'kyc_investment_presentation',
  kycManagementBios: 'kyc_management_bios',
  kycManagementCvs: 'kyc_management-cvs',
  kycManagementPictures: 'kyc_management_pictures',
  kycProofOfInvestor: 'kyc_proof_investor',
  kycShareholdersCertificate: 'kyc_shaholders_certificate',
  kycAnnualReport: 'kyc_annual_report',
  kycMemorandium: 'kyc_memorandium',
  kycSignatoriesAuthorization: 'kyc_signatories_authorization',
  kycOrganizationChart: 'kyc_organization_chart',
  kycBusinessModel: 'kyc_business_model'
})

export const documentTypes = Object.freeze({
  ...kycDocumentTypes,
  fundLogo: 'fund_logo',
  fundDocument: 'fund_document',
  navReport: 'nav_report',
  syndicate_member_photo: 'alpha',
  bravo: 'bravo',
  charlie: 'charlie',
  delta: 'delta',
  tokenTerms: 'token_terms',
  tokenIcon: 'asset_logo',
  tokenLogo: 'asset_logo',
  tokenMetrics: 'token_metrics',
  kycIdDocument: 'kyc_id_document',
  kycProofOfAddress: 'kyc_poa',
  limitsProofOfIncome: 'limits_poi',
  contract: 'contract',
  invoice: 'invoice',
  dispute: 'dispute'
})



// WEBPACK FOOTER //
// ./src/js/const/documents.const.js